module.exports = __webpack_public_path__ + "static/media/friday-che-big@2x.e7b05273.png";